/**
 * Filters out empty values (undefined, null, empty strings) from an object.
 *
 * @param params - The object containing parameters to filter
 * @returns A new object with only non-empty values
 *
 * @example
 * ```ts
 * const params = {
 *   name: "Marta",
 *   email: "",
 *   age: undefined,
 *   city: null,
 *   active: true
 * }
 *
 * const filtered = filterEmptyParams(params)
 * // Result: { name: "Marta", active: true }
 * ```
 */
export function filterEmptyParams<TParams extends object>(params: TParams): TParams {
    return Object.fromEntries(
        Object.entries(params).filter(([_, value]) => {
            // Keep the value if it's not undefined, null, or empty string
            return value !== undefined && value !== null && value !== ""
        }),
    ) as TParams
}

